import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  FormControl,
  Divider,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { api } from "../../../redux/api";

function RegularExpressionDialog(props) {
  const {
    openRegExDialog,
    regExDocPath,
    handleRegExClose,
    setValue,
    regExValue,
    disableReplaceValue = true,
    replaceValue
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [regularExpression, setRegularExpression] = useState("");
  const [replacementValue, setReplacementValue] = useState("");
  const [testData, setTestData] = useState("");
  const [testResult, setTestResult] = useState("");
  const [regExErrorMsg,setRegExErrorMsg] = useState('');
  const [testDataErrorMsg,setTestDataErrorMsg] = useState('')
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (regExValue) setRegularExpression(regExValue);
    setReplacementValue(replaceValue || "");
  }, [openRegExDialog]);

  const handleRegularExpressionChange = (e) => {
    const value = e.target.value;
    setRegularExpression(value);
    setRegExErrorMsg('')
  };
  const handleReplacementValue = (e) => {
    const value = e.target.value;
    setReplacementValue(value);
  };

  const handleTestData = (e) => {
    const value = e.target.value;
    setTestData(value);
    setTestDataErrorMsg('')
  };
  const testButtonHandler = () => {
    if (!regularExpression) {
      setRegExErrorMsg(t('REG_EX_ERROR'));
      return;
    }
  
    if (!testData) {
      setTestDataErrorMsg(t('TEST_DATA_ERROR'));
      return;
    }
    if (regularExpression && testData) {
      setLoading(true);
      const postData = {
        data: `${testData}\n~Replace:${regularExpression} With:${replacementValue} (Reg Ex)`,
      };

      dispatch(
        api.endpoints.testRegularExpression.initiate({
          data: postData.data,
        })
      )
        .then((response) => {
          if (response && response.data.current_state === 'SUCCESS') {
            setTestResult(response.data.data);
          }
          else {
            setTestResult(response.data)
          }
          setLoading(false);
        })
        .catch((error) => setLoading(false));
    }
  };
  const handleOkClick = () => {
    setValue(regularExpression);
    handleRegExClose();
  };

  return (
    <>
      <Dialog open={openRegExDialog} maxWidth={"lg"} fullWidth={true}>
        <DialogTitle className="dialog-header">
          <div className="title">{t("DIAG_REG_EX_BUILDER_TIT")}</div>
          <div className="description">{t("DIAG_REG_EX_BUILDER_DESC")}</div>
        </DialogTitle>
        <DialogContent
          className="dialog-content"
          sx={{ height: "580px", maxHeight: "580px", overflow: "hidden" }}
          dividers>
          <Grid container spacing={1} columns={13}>
            <Grid item xs={8}>
              {regExDocPath ? (
                <iframe
                  className="docFrame"
                  style={{ height: "75%" }}
                  title="regularExpressionHelp"
                  src={regExDocPath}></iframe>
              ) : (
                ""
              )}
            </Grid>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              style={{ padding: "8px" }}
            />
            <Grid item xs={4} style={{ height: "80vh" }}>
              <div
                className="flex-column"
                style={{ gap: "20px", margin: "20px" }}>
                <FormControl className="width-100" size="small">
                  <TextField
                    label={t("LBL_REG_EXPR")}
                    variant="outlined"
                    size="small"
                    className="width-100"
                    name={"regularExpression"}
                    value={regularExpression}
                    error={regExErrorMsg.length > 0}
                    helperText={regExErrorMsg}
                    onChange={handleRegularExpressionChange}></TextField>
                </FormControl>
                <FormControl className="width-100" size="small">
                  <TextField
                    label={t("LBL_REPLACEMENT_VAL")}
                    variant="outlined"
                    size="small"
                    disabled={disableReplaceValue}
                    className="width-100"
                    name={"replacementValue"}
                    value={replacementValue}
                    onChange={handleReplacementValue}></TextField>
                </FormControl>
                <Typography>{t("LBL_TEST_REG_EXPR_HERE")}</Typography>
                <FormControl className="width-100" size="small">
                  <div className="flex">
                    <TextField
                      variant="outlined"
                      size="small"
                      label={t("LBL_TEST_DATA")}
                      type="text"
                      className={"width-100"}
                      name={"testData"}
                      value={testData}
                      onChange={handleTestData}
                      error={testDataErrorMsg.length > 0}
                      helperText={testDataErrorMsg}
                    />
                    <Button
                      variant="outlined"
                      size="small"
                      disableElevation
                      className="margin-left-4"
                      sx={{
                        width: "40px",
                        padding: "4px 8px",
                        minWidth: "40px",
                      }}
                      onClick={testButtonHandler}>
                      {loading ? <CircularProgress size={"16px"}/> : t("MNU_TEST")}
                    </Button>
                  </div>
                </FormControl>
                <FormControl className="width-100" size="small">
                  <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_TEST_RESULT")}
                    type="text"
                    className={"width-100"}
                    name={"testResults"}
                    value={testResult}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </FormControl>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dp-actions">
          <Button size="small" variant="outlined" onClick={handleOkClick}>
            {t("APPLY")}
          </Button>
          <Button size="small" variant="outlined" onClick={handleRegExClose}>
            {t("BTN_CLOSE")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RegularExpressionDialog;
